import { useEffect } from 'react';

let scrollLocksActive = 0;
let lastScrollPosition = 0;

const lockScrollBars = () => {
    if (scrollLocksActive === 0) {
        lastScrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
        document.documentElement.classList.add('overlayopen');
        window.addEventListener('resize', handleResize);
        setImmediate(handleResize);
        window.requestAnimationFrame(() => {
            const root = document.getElementById('root');
            if (root) {
                root.scrollTop = lastScrollPosition;
            }
        });
    }
    scrollLocksActive += 1;
};

const unlockScrollbars = () => {
    scrollLocksActive -= 1;
    if (scrollLocksActive === 0) {
        document.documentElement.classList.remove('overlayopen');
        document.body.scrollTop = lastScrollPosition;
        document.documentElement.scrollTop = lastScrollPosition;
        window.removeEventListener('resize', handleResize);
    }
};

const handleResize = () => {
    const root = document.getElementById('root');
    if (root) {
        root.style.height = document.documentElement.clientHeight + 'px';
        root.style.minHeight = document.documentElement.clientHeight + 'px';
    }
    document.documentElement.style.height = document.documentElement.clientHeight + 'px';
};

export const useOverlayScrollLock = (isActive: boolean) => {
    useEffect(() => {
        if (isActive) {
            lockScrollBars();
            return unlockScrollbars;
        }
        return undefined;
    }, [isActive]);
};
